<template>
  <div class="selection-actions" data-figma-node="2739:6800" role="group" aria-label="Selection actions">
    <button
      v-if="!isLayered"
      type="button"
      :aria-label="`Select All ${selectAllTargetLabel}`"
      :disabled="!hasShapes"
      @click="actions.selectAll"
    >
      Select All<br>{{ selectAllTargetLabel }}
      <span
        v-if="!hasShapes"
        class="selection-actions__disabled-mark"
        aria-hidden="true"
      >×</span>
    </button>
    <button v-if="!isLayered" type="button" :aria-label="`Select All ${gridStore.selectedColor?.label || 'Color'}`" :disabled="!hasShapes || !gridStore.selectedColor" @click="actions.selectCurrentColor">
      Select All<br>{{ gridStore.selectedColor?.label || 'Color' }}
      <span v-if="!hasShapes || !gridStore.selectedColor" class="selection-actions__disabled-mark" aria-hidden="true">×</span>
    </button>
    <button type="button" aria-label="Deselect All Shapes" :disabled="!hasSelection" @click="actions.deselectAll">Deselect<br>All Shapes<span v-if="!hasSelection" class="selection-actions__disabled-mark" aria-hidden="true">×</span></button>
  </div>
</template>

<script setup lang="ts">
import { isLayeredShape } from "~/shared/layeredEngraving"
const actions = useNewStudioActions()
const { hasSelection, hasShapes, selectAllTargetLabel } = actions
const gridStore = useGridStore()
const isLayered = computed(() => isLayeredShape(gridStore.selectedShape))
</script>

<style scoped>
.selection-actions {
  position: absolute;
  z-index: 4;
  bottom: 18px;
  left: 50%;
  display: flex;
  width: 353px;
  gap: 10px;
  transform: translateX(-50%);
  pointer-events: auto;
}

.selection-actions button {
  position: relative;
  width: 111px;
  height: 76px;
  padding: 15px 7px;
  border: 2px solid var(--studio-border);
  border-radius: 8px;
  background: var(--studio-surface);
  box-shadow: var(--studio-card-shadow);
  color: var(--studio-text);
  font: inherit;
  font-size: 12.5px;
  font-weight: var(--studio-font-semibold);
  line-height: 15px;
  cursor: pointer;
}

.selection-actions button:hover:not(:disabled) {
  background: #dfe4e5;
  border-color: transparent;
  color: #5f6270;
}

.selection-actions button:disabled {
  opacity: var(--studio-disabled-opacity);
  cursor: not-allowed;
}

.selection-actions__disabled-mark {
  position: absolute;
  top: 3px;
  right: 6px;
  font-size: 12px;
  font-weight: var(--studio-font-bold);
}

.selection-actions button:focus-visible {
  outline: 3px solid var(--studio-focus-ring);
  outline-offset: 2px;
}
</style>
